import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useHalloween } from "./HalloweenProvider";
import Bat, { BatSvg } from "./Bat";
import HalloweenLightning from "./HalloweenLightning";

const WEB_PATH =
  "M0 0 L240 0 M0 0 L240 70 M0 0 L240 170 M0 0 L170 240 M0 0 L70 240 M0 0 L0 240 " +
  "M40 0 Q38 22 40 42 Q22 38 0 40 M80 0 Q74 44 80 84 Q44 74 0 80 M120 0 Q110 66 120 126 Q66 110 0 120 " +
  "M160 0 Q146 88 160 168 Q88 146 0 160 M200 0 Q182 110 200 210 Q110 182 0 200";

const Web = ({ side }) => (
  <svg className={`hk-web hk-web-${side}`} viewBox="0 0 240 240" aria-hidden="true">
    <path d={WEB_PATH} />
  </svg>
);

const BG_BATS = [
  { left: "8%", top: "34%", rotate: -12 },
  { left: "71%", top: "22%", rotate: 10 },
  { left: "88%", top: "58%", rotate: -6 },
  { left: "24%", top: "72%", rotate: 14 },
];

function useIsMobile() {
  const [mobile, setMobile] = useState(() => window.matchMedia("(max-width: 768px)").matches);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const onChange = (e) => setMobile(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return mobile;
}

export default function HalloweenDecor() {
  const { enabled } = useHalloween();
  const isMobile = useIsMobile();
  const { pathname } = useLocation();

  if (!enabled) return null;

  const isHome = pathname === "/";
  const count = isMobile ? (isHome ? 5 : 4) : isHome ? 12 : 9;

  return (
    <>
      <div className="hk-scene" aria-hidden="true" data-testid="halloween-scene">
        <img className="hk-scene-skyline" src="/halloween/skyline.webp" alt="" loading="lazy" />
        <img className="hk-scene-moon" src="/halloween/moon.webp" alt="" loading="lazy" />
        <img className="hk-scene-pumpkins" src="/halloween/pumpkins.webp" alt="" loading="lazy" />
      </div>
      <HalloweenLightning />
      <div className="hk-fog" aria-hidden="true" data-testid="halloween-fog">
        <span /><span /><span />
      </div>
      <Web side="left" />
      <Web side="right" />
      <div className="hk-bg-bats" aria-hidden="true">
        {BG_BATS.map((b) => (
          <svg key={`${b.left}-${b.top}`} className="hk-bg-bat" viewBox="0 0 100 50"
            style={{ left: b.left, top: b.top, transform: `rotate(${b.rotate}deg)` }}>
            <path d="M44 24 C34 9, 18 4, 1 11 C10 15, 13 22, 8 29 C17 24, 23 27, 27 36 C31 29, 37 28, 44 33 Z" />
            <path d="M56 24 C66 9, 82 4, 99 11 C90 15, 87 22, 92 29 C83 24, 77 27, 73 36 C69 29, 63 28, 56 33 Z" />
            <ellipse cx="50" cy="27" rx="5.5" ry="10" />
          </svg>
        ))}
      </div>
      <div className="hk-bats" aria-hidden="true" data-testid="halloween-bats">
        {Array.from({ length: count }, (_, i) => <Bat key={i} />)}
      </div>
    </>
  );
}

export { BatSvg };
